import { useCallback } from 'react';
import { VolumeOffFill, VolumeUp } from '@crabs-ai/web-icons';
import { ToolButton } from '@crabs-ai/ds-react';
import { useTranslations } from 'next-intl';
import { muteTrack, unmuteTrack } from '../../state/actions/mute-track';
import { TrackType } from '../../state/types';
import { useWriteContext } from '../../utils/use-context';

export const TimelineMuteTrack = ({ track }: { track: TrackType }) => {
  const { setState } = useWriteContext();
  const t = useTranslations();

  const toggle = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();

      setState({
        update: (state) =>
          track.muted
            ? unmuteTrack(state, track.id)
            : muteTrack(state, track.id),
        commitToUndoStack: true,
      });
    },
    [track.muted, setState, track.id],
  );

  const onPointerDown = useCallback((e: React.PointerEvent) => {
    e.stopPropagation();
  }, []);

  return (
    <ToolButton
      size="sm"
      state={track.muted ? 'selected' : 'default'}
      onClick={toggle}
      onPointerDown={onPointerDown}
      isShowTooltip
      tooltipNode={
        track.muted ? t('Editor.timeline.unmute') : t('Editor.timeline.mute')
      }
      tooltipPosition="top"
    >
      {track.muted ? <VolumeOffFill /> : <VolumeUp />}
    </ToolButton>
  );
};
